<app-toolbar></app-toolbar>
<mat-tab-group #tabGroup>
  <mat-tab label="Prepare">
    <app-prepare [tabGroup]="tabGroup"></app-prepare>
  </mat-tab>
  <mat-tab label="Decide" disabled="true">
    <app-decide></app-decide>
  </mat-tab>
  <mat-tab label="Support"> Support </mat-tab>
</mat-tab-group>
<app-footer></app-footer>
